module.exports = __webpack_public_path__ + "img/运动明星.73e1888.png";